import {LocalizationValueModel} from "@/shared";

export default class LocalizationModel {

  Key: string = "";
  Values: Array<LocalizationValueModel> = new Array<LocalizationValueModel>();

  constructor(obj?: Partial<LocalizationModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
